import axios from 'axios';
import {
	annualIncomeFilter,
	casteFilter,
	countryFilter,
	drinkingHabitsFilter,
	foodHabitsFilter,
	gotraFilter,
	maritalStatusFilter,
	motherTongueFilter,
	nakshatraFilter,
	NRIFilter,
	occupationFilter,
	qualificationFilter,
	rashiFilter,
	smokingHabitsFilter,
	stateFilter,
} from '../components/constants/filters';
import { BACKEND_URL } from './Constants';
import {
	addFavouriteMutation,
	extendProfileCompleteReminderMutation,
	removeFavouriteMutation,
	updateFilterPreferenceMutation,
	updateProfileImageMutation,
	updateProfileMutation,
} from './mutations';
import { filter, getUploadDataQuery, search, getProfileByIdQuery, getPreviewProfilesQuery, getFavouritesQuery } from './queries';
import { MAX_AGE, MAX_HT_CM, MIN_AGE, MIN_HT_CM } from '../components/constants/profileData';
import { PAGE_SIZE } from '../components/constants/Constants';
import { toast } from 'react-toastify';

export const updateProfile = async (accessToken, profile) => {
	const response = await axios.post(
		BACKEND_URL,
		updateProfileMutation(accessToken, profile)
	);
	return response;
};

export const updateProfileImage = async (accessToken, keys) => {
	const response = await axios.post(
		BACKEND_URL,
		updateProfileImageMutation(accessToken, keys), 
		{timeout: 5000}
	);
	return response;
};

export const getProfiles = async (
	accessToken,
	filters,
	pageNumber,
	pageSize,
	searchText
) => {
	let response = {};
	if (searchText?.length > 0) {
		response = await axios.post(
			BACKEND_URL,
			search(accessToken, filters, pageNumber, pageSize, searchText)
		);
	} else {
		response = await axios.post(
			BACKEND_URL,
			filter(accessToken, filters, pageNumber, pageSize)
		);
	}
	return response;
};

export const getUploadData = async (accessToken) => {
	const response = await axios.post(BACKEND_URL, getUploadDataQuery(accessToken), {timeout: 5000});
	return response.data;
};

export const addFavorite = async (accessToken, userId) => {
	const response = await axios.post(
		BACKEND_URL,
		addFavouriteMutation(accessToken, userId)
	);
	return response.data;
};

export const removeFavorite = async (accessToken, userId) => {
	const response = await axios.post(
		BACKEND_URL,
		removeFavouriteMutation(accessToken, userId)
	);
	return response.data;
};

export const updateFilterPreference = async (token, filterPreference) => {
	
	const response = await axios.post(
		BACKEND_URL,
		updateFilterPreferenceMutation(token, filterPreference)
	);
	return response.data;
}

export const extendProfileCompleteReminderTime = async (token) => {
	const response = await axios.post(
		BACKEND_URL,
		extendProfileCompleteReminderMutation(token)
	);
	return response.data;
}

export const cmToFeetInches = (cm) => {
  const totalInches = cm / 2.54;
  const feet = Math.floor(totalInches / 12);
  const inches = Math.round(totalInches % 12);
  return `${feet}ft ${inches}in`;
};

export const feetInchesToCm = (feet, inches) => {
	// Convert feet and inches to cm
	return Math.round((feet * 12 + inches) * 2.54);
};
export const cmToFeetInchesValue = (cm) => {
	const totalInches = cm / 2.54;
	const feet = Math.floor(totalInches / 12);
	const inches = Math.round(totalInches % 12);
	return [feet, inches];
  };
export const intialFilterState = () => {
	return {
		ageFilterState: [MIN_AGE, MAX_AGE],
		heightFilterState: [MIN_HT_CM, MAX_HT_CM],
		maritalStatusFilterState: { ...maritalStatusFilter() },
		occupationFilterState: { ...occupationFilter() },
		stateFilterState: { ...stateFilter() },
		countryFilterState: { ...countryFilter() },
		casteFilterState: { ...casteFilter() },
		gotraFilterState: {...gotraFilter()},
		qualificationFilterState: { ...qualificationFilter() },
		annualIncomeFilterState: { ...annualIncomeFilter() },
		foodHabitsFilterState: { ...foodHabitsFilter() },
		smokingHabitsFilterState: { ...smokingHabitsFilter() },
		drinkingHabitsFilterState: { ...drinkingHabitsFilter() },
		NRIFilterState: { ...NRIFilter() },
		rashiFilterState: { ...rashiFilter() },
		nakshatraFilterState: { ...nakshatraFilter() },
		motherTongueFilterState: { ...motherTongueFilter() },
	}
};

export const createFilterQuery = (filters, age, gender, height=[92, 244]) => {
	// After enabling select all, selected count will be == options list initially, if all are selected its the same as none are.
	let filtersApplied = filters.filter((filter) => filter.selectedCount > 0 && filter.filters.length !== filter.selectedCount);
	// console.log('filters applied are', filtersApplied);
	let listOfFilters = [];
	let genderFilter = 'gender: ';
	if (gender === 'male') {
		genderFilter = genderFilter.concat('female');
	} else if (gender === 'female') {
		genderFilter = genderFilter.concat('male');
	} else {
		genderFilter = '';
	}

	genderFilter.length > 0 && listOfFilters.push(genderFilter);
	if (filtersApplied.length) {
		filtersApplied.forEach((currentFilter) => {
			let currentFilterString = currentFilter.backendProperty + ':=[';
			currentFilter.filters.forEach((filterOption) => {
				if (filterOption.checked) {
					if (currentFilter.isBinary) {
						let filterKeyword =
							filterOption.label === 'Yes' ? 'true' : 'false';
						currentFilterString = currentFilterString.concat(
							filterKeyword + ','
						);
					} else {
						currentFilterString = currentFilterString.concat(
							filterOption.value + ','
						);
					}
				}
			});
			let currentFilterStringLength = currentFilterString.length;
			currentFilterString = currentFilterString
				.substring(0, currentFilterStringLength - 1)
				.concat(']');
			// console.log('apprnding filter', {
			// 	currentFilterString,
			// 	currentFilter,
			// });
			listOfFilters.push(currentFilterString);
		});
	}

	let ageFilter = 'dob:[';
	let lower = age[0],
		upper = age[1];
	let latestDate = new Date(),
		oldestDate = new Date();
	latestDate.setFullYear(latestDate.getFullYear() - lower);
	oldestDate.setFullYear(oldestDate.getFullYear() - upper);
	// console.log('debug dates filter', {
	// 	lower,
	// 	upper,
	// 	latestDate,
	// 	oldestDate,
	// 	current: Date.now(),
	// });
	ageFilter = ageFilter.concat(
		parseInt(oldestDate.valueOf() / 1000) +
			'..' +
			parseInt(latestDate.valueOf() / 1000) +
			']'
	);
	let heightFilter='height:[';
	let heightLower =  Math.floor(height[0]),
		heightUpper = Math.ceil(height[1]);
	heightFilter =  heightFilter.concat(`${heightLower}..${heightUpper}]`)
	// console.log('debug constructed date filter', ageFilter);
	listOfFilters.push(ageFilter, heightFilter);
	return listOfFilters;
};

export const postFetchUserMessage = (totalPages) => {

	var minProfileCount = (totalPages-1)*PAGE_SIZE;
	var userMessage = minProfileCount > 0 ?`Found ${minProfileCount}+ profiles matching your filters! Please scroll down to see entire list.` :
	minProfileCount === 0 ? `Found profiles matching your filters! Please scroll down to see entire list.` : "No profiles found for the applied filters";	
	if(minProfileCount<0)
		toast.info(userMessage, {timeOut: 3000});
	else
		toast.success(userMessage, {timeOut: 3000});
}

export const getProfileById = async (token, id) => {
  return await axios.post(BACKEND_URL, getProfileByIdQuery(token, id), {timeout: 5000});
};

export const getPreviewProfiles = async (token) => {
  return await axios.post(BACKEND_URL, getPreviewProfilesQuery(token), {timeout: 5000});
};

export const getFavourites = async (accessToken, page, perPage, filters = [], searchText = "") => {
  const response = await axios.post(
    BACKEND_URL,
    getFavouritesQuery(accessToken, page, perPage, filters, searchText)
  );
  return response;
};
